/**
 * Path / Pathology role helpers.
 * Keep accepting legacy role keys from the API while showing Pathology Admin in the UI.
 */

export const normalizeRoleKey = (roleName) =>
  String(roleName || "")
    .toLowerCase()
    .trim()
    .replace(/[\s_-]+/g, "");

/** path admin / pathadmin / pathology admin / pathologyadmin */
export const isPathAdminRole = (roleName) => {
  const key = normalizeRoleKey(roleName);
  return key === "pathadmin" || key === "pathologyadmin";
};

/** pathdesk (legacy desk role used for pathology staff) */
export const isPathDeskRole = (roleName) =>
  normalizeRoleKey(roleName) === "pathdesk";

/** Any pathology staff role (desk or admin variants) */
export const isPathModuleStaffRole = (roleName) =>
  isPathDeskRole(roleName) || isPathAdminRole(roleName);

/**
 * User-facing role label. Maps path admin / pathdesk variants to Pathology Admin.
 * Other roles are returned unchanged (caller may still upper-case).
 */
export const formatRoleDisplayName = (roleName) => {
  if (!roleName) return "";
  if (isPathModuleStaffRole(roleName)) return "Pathology Admin";
  return String(roleName);
};

/**
 * Label for User Role dropdown options (create/edit staff).
 * Uses API username when present, but always shows Pathology Admin for path roles.
 */
export const formatUserRoleOptionLabel = (roleName, username) => {
  if (isPathModuleStaffRole(roleName) || isPathModuleStaffRole(username)) {
    return "Pathology Admin";
  }
  return username || roleName || "";
};

/** @deprecated use formatUserRoleOptionLabel */
export const formatStaffRoleLabel = formatUserRoleOptionLabel;

/** Capability name as stored on subscription (do not rename for API matching). */
export const PATH_INVENTORY_CAPABILITY = "Path Inventory";

/** UI label for Path Inventory surfaces */
export const PATHOLOGY_INVENTORY_LABEL = "Pathology Inventory";
